import {
    StyledFooterColumn,
    StyledTotalAmount,
} from 'features/OrderPreview/ui/OrderTotalPricePreview/styles'
import {
    companyRefundWayOptions,
    refundWayOptions,
    useOrderRefundController,
} from 'features/Booking/model/hooks'
import { Flex } from 'shared/components/Flex'
import { Button } from 'shared/components/Button'
import { Input } from 'shared/components/Input'
import { Autocomplete } from 'shared/components/Autocomplete'
import { InputContainer, Label } from 'shared/components/Input/style'

import { StyledFooterContainer } from './styles'
import { RefundItem } from './RefundItem'

export const RefundOrder = () => {
    const {
        totalPrice,
        isCompany,
        selectedBookings,
        originalOrder,
        currentRefundWay,

        setCurrentRefundWay,
        onChangeNomenclaturesCount,
        getNomenclaturesCount,
        isBookingChecked,
        isNomenclatureChecked,
        refund,
        fullRefund,
        onChangeBookingsToRefund,
        onChangeBookingsAreaCountToRefund,
        getAreaCount,

        isNomenclatureDisabled,
        isAreaDisabled,

        loading,

        refundComment,
        setRefundComment,
    } = useOrderRefundController()

    if (!originalOrder) {
        return <>Заказ не найден</>
    }

    return (
        <StyledFooterContainer>
            <Flex flexDirection='column' gap={5}>
                {originalOrder.bookings.map((booking, index) => (
                    <RefundItem
                        booking={booking}
                        key={index}
                        onChangeBookingsToRefund={onChangeBookingsToRefund}
                        isBookingChecked={isBookingChecked}
                        isNomenclatureChecked={isNomenclatureChecked}
                        onChangeNomenclaturesCount={onChangeNomenclaturesCount}
                        getNomenclaturesCount={getNomenclaturesCount}
                        onChangeBookingsAreaCountToRefund={
                            onChangeBookingsAreaCountToRefund
                        }
                        getAreaCount={getAreaCount}
                        isNomenclatureDisabled={isNomenclatureDisabled}
                        isAreaDisabled={isAreaDisabled}
                        loading={loading}
                    />
                ))}
                <Autocomplete
                    value={currentRefundWay}
                    onChange={setCurrentRefundWay}
                    options={
                        isCompany ? companyRefundWayOptions : refundWayOptions
                    }
                    label='Способ возврата'
                    placeholder='Выберете способ возврата'
                    required
                />
                <InputContainer>
                    <Label>Комментарий</Label>
                    <textarea
                        className='textarea'
                        name=''
                        value={refundComment}
                        onChange={e => setRefundComment(e.target.value)}
                        placeholder='Напишите комментарий'
                    />
                </InputContainer>
            </Flex>

            <StyledFooterColumn>
                <StyledTotalAmount mode='total'>
                    Итого к возврату
                </StyledTotalAmount>
                <Input value={totalPrice} disabled />
            </StyledFooterColumn>
            <Button
                disabled={selectedBookings?.length < 1 || !currentRefundWay}
                onClick={refund}
            >
                Оформить возврат
            </Button>
            <Button disabled={!currentRefundWay} onClick={fullRefund}>
                Оформить полный возврат
            </Button>
        </StyledFooterContainer>
    )
}
